export const IMPERSONATION_AGENT_LOOKUP = 'IMPERSONATION_AGENT_LOOKUP';
export const IMPERSONATION_AGENT_LOOKUP_FAIL = 'IMPERSONATION_AGENT_LOOKUP_FAIL';
export const IMPERSONATION_AGENT_LOOKUP_SUCCESS = 'IMPERSONATION_AGENT_LOOKUP_SUCCESS';
export const START_IMPERSONATION = 'START_IMPERSONATION';
export const START_IMPERSONATION_FAIL = 'START_IMPERSONATION_FAIL';
export const START_IMPERSONATION_SUCCESS = 'START_IMPERSONATION_SUCCESS';
export const STOP_IMPERSONATION = 'STOP_IMPERSONATION';
export const STOP_IMPERSONATION_SUCCESS = 'STOP_IMPERSONATION_SUCCESS';
export const STOP_IMPERSONATION_FAIL = 'STOP_IMPERSONATION_FAIL';
export const GET_IMPERSONATION_DATA = 'GET_IMPERSONATION_DATA';
export const GET_IMPERSONATION_DATA_SUCCESS = 'GET_IMPERSONATION_DATA_SUCCESS';
export const GET_IMPERSONATION_DATA_FAIL = 'GET_IMPERSONATION_DATA_FAIL';
export const GET_STATUS = 'GET_STATUS';
export const GET_STATUS_SUCCESS = 'GET_STATUS_SUCCESS';
export const GET_STATUS_FAIL = 'GET_STATUS_FAIL';
